var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ib-dropdown", {
    attrs: {
      data: _vm.options,
      placeholder: _vm.$t("search"),
      filtered: "",
      width: _vm.$media.m ? "380px" : "100%",
    },
    on: { change: _vm.selectOption },
    model: {
      value: _vm.searchFilter,
      callback: function ($$v) {
        _vm.searchFilter = $$v
      },
      expression: "searchFilter",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }